export const ChatbotLogEvents = {
  AI_CHAT_INIT: 'AI_CHAT_INIT',
  AI_CHAT_ACTIVATED: 'AI_CHAT_ACTIVATED',
};
